import { DEAD_ADDRESS, TRANSFER_TOPIC, VITALIK } from "../../integration.js";
import { CORE_PINNED_BLOCK_HASHES, CORE_PINNED_BLOCK_HEIGHTS, CORE_PINNED_TRANSACTION_HASHES } from "../pinned.js";
import { ERC20_BALANCE_OF_REFERENCE_CALLDATA } from "../fixture-inputs.js";
export const MONAD_TEST_CONFIG = {
    balance: { address: VITALIK },
    blockQuery: {
        block: CORE_PINNED_BLOCK_HEIGHTS.monad,
        fixture: "getBlockByNumberMonad",
    },
    balanceQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.monad,
        fixture: "getBalanceMonad",
    },
    tokenBalanceQuery: {
        address: VITALIK,
        // Live ERC-20 at the pinned height (~160 Transfer events in the same block);
        // Vitalik holds 0, which is deterministic and fine for exact-match fixtures.
        token: "0x754704Bc059F8C67012fEd69BC8A327a5aafb603",
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.monad,
        fixture: "getTokenBalanceMonad",
    },
    blockHashQuery: {
        hash: CORE_PINNED_BLOCK_HASHES.monad,
        fixture: "getBlockByHashMonad",
    },
    blockTransactionsQuery: {
        blockNumber: CORE_PINNED_BLOCK_HEIGHTS.monad,
        fixture: "getBlockTransactionsMonad",
    },
    transfersQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.monad,
        fixture: "getTransfersMonad",
    },
    simulateCallQuery: {
        to: "0x754704Bc059F8C67012fEd69BC8A327a5aafb603",
        data: ERC20_BALANCE_OF_REFERENCE_CALLDATA,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.monad,
        fixture: "simulateCallMonad",
    },
    traceTransactionQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.monad,
        fixture: "traceTransactionMonad",
    },
    tokenMetadataQuery: {
        address: "0x754704Bc059F8C67012fEd69BC8A327a5aafb603",
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.monad,
        fixture: "getTokenMetadataMonad",
    },
    tokenAllowanceQuery: {
        token: "0x754704Bc059F8C67012fEd69BC8A327a5aafb603",
        owner: VITALIK,
        spender: DEAD_ADDRESS,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.monad,
        fixture: "getTokenAllowanceMonad",
    },
    portfolioQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.monad,
    },
    receiptQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.monad,
        fixture: "getReceiptMonad",
    },
    transactionByHashQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.monad,
        fixture: "getTransactionByHashMonad",
    },
    estimateGasQuery: {
        to: VITALIK,
        fixture: "estimateGasMonad",
    },
    codeQuery: {
        address: "0x754704Bc059F8C67012fEd69BC8A327a5aafb603",
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.monad,
        fixture: "getCodeMonad",
    },
    logsQuery: {
        // Monad reference ERC-20 — 50-block window for log density.
        address: "0x754704Bc059F8C67012fEd69BC8A327a5aafb603",
        topic0: TRANSFER_TOPIC,
        fromBlock: String(CORE_PINNED_BLOCK_HEIGHTS.monad - 50),
        toBlock: String(CORE_PINNED_BLOCK_HEIGHTS.monad),
        fixture: "getLogsMonad",
    },
};
